import { lazy } from 'react';

const UserList = lazy(() => import('./List/UserList'));
const UserAdd = lazy(() => import('./Add/UserAdd'));
const UserEdit = lazy(() => import('./Edit/UserEdit'));

export { UserList, UserAdd, UserEdit };
